import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, message, Button, Modal, Input } from "antd";
import List from "../../../Commons/BasicModule/List";
import { getCyclesRequest, getCyclesState } from "../../../Stores/CycleSlice";
import { CheckCircleTwoTone, CloseCircleOutlined } from '@ant-design/icons';
import { onCreateTopupRequest } from "../../../Stores/TopupSlice";
import { getUserByIDRequest } from "../../../Stores/UserSlice";

// No Edit 
const tableField = ['id']
const columnTable = tableField.map((field) => ({
    title: field.replace(/_/g, ' ').toUpperCase(),
    dataIndex: field,
    key: field,
    render: (text, record) => {
        if (field === 'status') {
            return text === true ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CloseCircleOutlined style={{ color: 'red' }} />
        }
        if (field === 'amount') {
            return new Intl.NumberFormat('vn-VN', { style: 'currency', currency: 'VND' }).format(text);
        }
        return text;
    }
}))

const customColumn = [...columnTable,
    {
        title: 'Created At',
        dataIndex: 'created_at',
        key: 'created_at',
        sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
    },
    {
        title: 'Transaction Content',
        dataIndex: 'transaction_content',
        key: 'transaction_content'
    },
    {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        filters: [
            { text: 'Active', value: true },
            { text: 'Inactive', value: false },
        ],
        onFilter: (value, record) => record.status === value,
        render: (text, record) => {
            return text === true ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CloseCircleOutlined style={{ color: 'red' }} />
        }
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
        sorter: (a, b) => new Date(a.amount) - new Date(b.amount),
        render: (text, record) => {
            return new Intl.NumberFormat('vn-VN', { style: 'currency', currency: 'VND' }).format(text);
        }
    },
    {
        title: 'Cashback',
        dataIndex: 'cashback',
        key: 'cashback',
        sorter: (a, b) => new Date(a.cashback) - new Date(b.cashback),
    },
    {
        title: 'Cashback percent',
        dataIndex: 'cashback_percent',
        key: 'cashback_percent',
        sorter: (a, b) => new Date(a.cashback_percent) - new Date(b.cashback_percent),
    },
    {
        title: 'Bonus',
        dataIndex: 'is_bonus',
        key: 'is_bonus',
        width: 100,
        filters: [
            { text: 'Active', value: true },
            { text: 'Inactive', value: false },
        ],
        onFilter: (value, record) => record.is_bonus === value,
        render: (text, record) => {
            return text === true ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : <CloseCircleOutlined style={{ color: 'red' }} />
        }
    },
]

const TopupComponent = ({ data }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();

    const cyclesData = useSelector(getCyclesState);
    const [dataTable, setDataTable] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [amount, setAmount] = useState('');

    useEffect(() => {
        dispatch(getCyclesRequest());
    }, [])

    useEffect(() => {
        let topups = data.data.topups.map(topup => ({ ...topup }));
        // Sort topups by created_at
        topups.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        if (cyclesData) {
            cyclesData.map(cycle => {
                topups.map(topup => {
                    if (cycle.id == topup.cycle_id) {
                        topup.cycle_name = cycle.name
                    }
                })
            })
        }
        setDataTable(topups)
    }, [cyclesData, data])

    const onEditEvent = (record) => {
        navigate("/topup")
    }

    const showModal = () => {
        setIsModalVisible(true);
    };

    const handleOk = () => {
        // Call the API with the amount
        dispatch(onCreateTopupRequest({ amount, userId: id })).then((res) => {
            console.log(res)
            message.success('Top-up action executed');
            setIsModalVisible(false);
            dispatch(getUserByIDRequest(id))
        });
    };

    const handleCancel = () => {
        setIsModalVisible(false);
    };

    const actionSelection = [
        {
            label: "Top-up",
            func: showModal
        }
    ];

    return <Card
        style={{
            marginTop: 4,
        }}
        type="inner"
        title="Top-up History"
        loading={data.isLoading}

    >
        <div style={{ marginBottom: 16, textAlign: 'right' }}>
            {actionSelection.map(action => (
                <Button key={action.label} type="primary" onClick={action.func} style={{ marginRight: 8 }}>
                    {action.label}
                </Button>
            ))}
        </div>
        <List
            columnTable={customColumn}
            dataList={dataTable}
            onEditEvent={onEditEvent}
        />
        <Modal title="Top-up Amount" visible={isModalVisible} onOk={handleOk} onCancel={handleCancel}>
            <Input 
                placeholder="Enter amount" 
                value={amount} 
                onChange={(e) => setAmount(e.target.value)} 
            />
        </Modal>
    </Card>
}

export default TopupComponent